import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { movies, categories } from '@/mocks/movies';

export default function AboutPage() {
  return (
    <div className="min-h-screen pt-20 bg-background-50">
      {/* Header */}
      <section className="relative w-full py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
          <div className="max-w-3xl mt-6">
            <h1 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              关于极速影视
            </h1>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
              极速影视是一个致力于为影迷提供免费高清在线观影体验的平台。我们每日更新最新院线大片和热门推荐，所有电影资源高清不缓冲，让您随时随地畅享极致观影。
            </p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 text-center">
          <div className="p-6 rounded-lg bg-background-100">
            <p className="text-3xl md:text-4xl font-bold text-primary-500">{movies.length}+</p>
            <p className="text-sm text-foreground-500 mt-2">高清电影资源</p>
          </div>
          <div className="p-6 rounded-lg bg-background-100">
            <p className="text-3xl md:text-4xl font-bold text-accent-500">{categories.length - 1}</p>
            <p className="text-sm text-foreground-500 mt-2">电影分类覆盖</p>
          </div>
          <div className="p-6 rounded-lg bg-background-100">
            <p className="text-3xl md:text-4xl font-bold text-primary-500">99.9%</p>
            <p className="text-sm text-foreground-500 mt-2">播放成功率</p>
          </div>
          <div className="p-6 rounded-lg bg-background-100">
            <p className="text-3xl md:text-4xl font-bold text-accent-500">1000万+</p>
            <p className="text-sm text-foreground-500 mt-2">累计观影人次</p>
          </div>
        </div>
      </section>

      {/* Brand Introduction */}
      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-4xl">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            品牌介绍
          </h2>
          <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              <strong>极速影视</strong>成立于2024年，是国内领先的高清电影在线观看平台。我们以"极速不缓冲，高清免费看"为核心理念，致力于为广大影迷提供最新最全的电影资源。极速影视高清电影大全涵盖动作、喜剧、科幻、爱情、恐怖、动画、悬疑、剧情等全类型电影，满足不同观众的观影需求。
            </p>
            <p>
              极速影视最新院线频道每日同步更新国内外热门大片，确保用户能够第一时间观看到最新上映的精彩影片。极速影视热门推荐由专业编辑团队精心筛选，为您推荐口碑好片和人气佳作，让观影选择不再困难。
            </p>
            <p>
              我们拥有一支专业的技术团队，不断优化服务器架构和播放系统，确保每一位用户在极速影视免费在线观看电影时都能获得流畅不缓冲的观影体验。极速影视支持多种设备和分辨率，无论是在电脑、平板还是手机上，都能畅享高清画质。
            </p>
          </div>
        </div>
      </section>

      {/* Reputation */}
      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-4xl">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            用户口碑
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            <div className="p-5 rounded-lg bg-background-100">
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                "极速影视真的是我目前用过最好的免费观影平台！电影资源特别全，画质也很清晰，而且真的不缓冲。推荐给所有喜欢看电影的朋友！"
              </p>
              <p className="text-xs text-foreground-500">—— 影迷小王，北京</p>
            </div>
            <div className="p-5 rounded-lg bg-background-100">
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                "极速影视最新院线更新速度太快了，基本上电影上映没多久就能在上面找到。极速影视热门推荐也帮我发现了很多冷门好片，太赞了！"
              </p>
              <p className="text-xs text-foreground-500">—— 电影达人李明，上海</p>
            </div>
            <div className="p-5 rounded-lg bg-background-100">
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                "界面简洁干净，没有乱七八糟的广告，分类也很清晰。极速影视高清电影大全收录的电影质量都很高，已经成为我的日常观影首选了。"
              </p>
              <p className="text-xs text-foreground-500">—— 追剧女孩小陈，广州</p>
            </div>
            <div className="p-5 rounded-lg bg-background-100">
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                "周末在家用极速影视连续看了三部科幻大片，全程高清不缓冲，体验完爆其他平台。极速影视免费在线观看真的很良心，值得推荐！"
              </p>
              <p className="text-xs text-foreground-500">—— 科幻迷老张，深圳</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="max-w-4xl">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            联系我们
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="p-6 rounded-lg bg-background-50 flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 mb-4">
                <i className="ri-mail-line text-primary-500 text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">电子邮箱</h3>
              <p className="text-sm text-foreground-600">contact@jisumovies.com</p>
            </div>
            <div className="p-6 rounded-lg bg-background-50 flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                <i className="ri-phone-line text-accent-500 text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">客服电话</h3>
              <p className="text-sm text-foreground-600">400-888-6688</p>
            </div>
            <div className="p-6 rounded-lg bg-background-50 flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 mb-4">
                <i className="ri-map-pin-line text-secondary-500 text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">公司地址</h3>
              <p className="text-sm text-foreground-600">北京市朝阳区光华路88号</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-4xl">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <div className="space-y-3">
            {[
              { q: '极速影视真的全部免费吗？', a: '是的，极速影视高清电影大全所有电影资源均免费在线观看，无需付费或注册会员即可畅享全部高清大片。' },
              { q: '极速影视播放会缓冲吗？', a: '极速影视采用先进的CDN加速和智能码率调节技术，确保在网络正常的情况下实现流畅播放不缓冲。我们持续优化服务器性能，为用户提供极致的观影体验。' },
              { q: '极速影视最新院线多久更新一次？', a: '极速影视最新院线频道每日更新，同步国内外最新上映的热门电影资源。您可以在"最新上映"栏目中找到当天更新的所有电影。' },
              { q: '在极速影视上可以看哪些类型的电影？', a: '极速影视高清电影大全涵盖动作、喜剧、科幻、爱情、恐怖、动画、悬疑、剧情等八大类电影，同时每个分类下还有丰富的子类型，满足不同口味观众的需求。' },
              { q: '极速影视支持哪些设备观看？', a: '极速影视支持电脑、平板、手机等多种设备在线观看，界面自适应适配不同屏幕尺寸，让您随时随地畅享高清观影体验。' },
            ].map((faq, i) => (
              <details key={i} className="group rounded-lg bg-background-100 overflow-hidden">
                <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer hover:bg-background-200 transition-colors">
                  <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-sm flex-shrink-0"></i>
                </summary>
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* Schema.org */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于极速影视",
            "description": "极速影视是一个致力于为影迷提供免费高清在线观影体验的平台。",
            "url": "https://www.jisumovies.com/about",
            "isPartOf": {
              "@type": "WebSite",
              "name": "极速影视",
              "url": "https://www.jisumovies.com/"
            },
            "inLanguage": "zh-CN",
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "首页",
                  "item": "https://www.jisumovies.com/"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "关于我们"
                }
              ]
            },
            "mainEntity": {
              "@type": "Organization",
              "name": "极速影视",
              "url": "https://www.jisumovies.com/",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "400-888-6688",
                "email": "contact@jisumovies.com",
                "contactType": "customer service",
                "availableLanguage": "Chinese"
              },
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "北京",
                "addressRegion": "北京",
                "streetAddress": "朝阳区光华路88号",
                "addressCountry": "CN"
              }
            }
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "极速影视真的全部免费吗？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "是的，极速影视高清电影大全所有电影资源均免费在线观看，无需付费或注册会员即可畅享全部高清大片。"
                }
              },
              {
                "@type": "Question",
                "name": "极速影视播放会缓冲吗？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "极速影视采用先进的CDN加速和智能码率调节技术，确保在网络正常的情况下实现流畅播放不缓冲。"
                }
              },
              {
                "@type": "Question",
                "name": "极速影视最新院线多久更新一次？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "极速影视最新院线频道每日更新，同步国内外最新上映的热门电影资源。"
                }
              },
              {
                "@type": "Question",
                "name": "在极速影视上可以看哪些类型的电影？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "极速影视高清电影大全涵盖动作、喜剧、科幻、爱情、恐怖、动画、悬疑、剧情等八大类电影。"
                }
              },
              {
                "@type": "Question",
                "name": "极速影视支持哪些设备观看？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "极速影视支持电脑、平板、手机等多种设备在线观看，界面自适应适配不同屏幕尺寸。"
                }
              }
            ]
          }),
        }}
      />
    </div>
  );
}